const tabContainer = document.querySelector(".tab-images-tab-heading-block");
const tabHeading = document.querySelectorAll(".tab-images-tab-heading");
const tabBlock = document.querySelectorAll(".tab-images-block");

tabContainer.addEventListener("click", function(e){
  const clicked = e.target.closest(".tab-images-tab-heading");
  if (!clicked) return null;
  tabHeading.forEach( th => th.classList.remove('tab-images-tab-heading--active') );
  clicked.classList.add("tab-images-tab-heading--active");
  tabBlock.forEach( th => th.classList.remove('tab-images-block--active') );
  document.querySelector(`.tab-images-block--${ clicked.dataset.tab }`).classList.add("tab-images-block--active");
});

const modal = document.getElementsByClassName('idMyModal');
const img = document.getElementsByClassName('toZoom');
const modalImg = document.getElementsByClassName('modal-content');
for ( let i = 0; i < img.length; i++ ) {
  img[i].onclick = function () {
    modal[i].style.display = "block";
    modalImg[i].src = this.dataset.src;
  }
}

var span = document.getElementsByClassName("close");
for ( let i = 0; i < span.length; i++ ) {
  span[i].onclick = function() { 
    modal[i].style.display = "none";
  }
}